<style lang="stylus">
    .header-close
        justify-content space-between
        span
            line-height 24px
            font-size 18px
            color #303133

    .bg-body
        display flex
        padding 30px 20px
        .body-preview
            margin-left 32px
            .priview-word
              cursor pointer
              margin-top 20px
              text-align center
              color #9E9E9E
              font-size 14px
            .priview-img-ava
                width 140px
                height 140px
                border-radius 50%

    .body-btn
        display flex
        padding-left 20px
        justify-content space-between
        .btn-reflash, .btn-icon
            color #606266
            width 135px
            display flex
            justify-content space-between
            cursor pointer
        .btn-icon
            svg
                width 22px
                height 22px
        .btn-file
            display none
            cursor pointer
            position absolute
            width 47px
            z-index 8000
            opacity 0
</style>
<template>
    <div v-if="ishow">
        <Dialog :width="type == 1 ? '540px' : '980px'" class="per-edit">
            <div class="header-close">
                <span>{{ type == 1 ? $t("uploadAvatar") : "上传背景" }}</span>
                <iconSymbol :name="'Del'" @click.native="cancel" />
            </div>
            <div class="bg-body">
                <vue-cropper
                    v-if="type == 2"
                    ref="cropper"
                    :style="'max-width:1200px;height:320px'"
                    :mode="'contain'"
                    :center-box="false"
                    :fixed="true"
                    :fixed-number="[4, 1]"
                    :can-move="true"
                    :can-scale="true"
                    :auto-crop="true"
                    :img="picture"
                />
                <vue-cropper
                    v-if="type == 1"
                    ref="cropper"
                    :style="'width:320px;height:320px'"
                    :mode="'cover'"
                    :center-box="false"
                    :fixed="true"
                    :auto-crop-width="128"
                    :auto-crop-height="128"
                    :fixed-box="true"
                    :fixed-number="[128, 128]"
                    :can-move="false"
                    :can-scale="false"
                    :auto-crop="true"
                    :img="picture"
                    @mouseup.native="preview"
                />
                <div v-if="type == 1" class="body-preview">
                    <img class="priview-img-ava" :src="newImg" />
                    <p class="priview-word" @click="preview">
                        {{ $t("avatarPreview") }}
                    </p>
                </div>
            </div>
            <div class="body-btn" :style="{ width: type == 1 ? '320px' : '542px' }">
                <input ref="avafile" accept=".jpg,.jpeg,.png,.gif" type="file" :title="'点击更换图片'" class="btn-file" @change="reChoose($event)" />
                <p class="btn-reflash" @click="selectImg">
                    {{ $t("Reselect") }}
                </p>
                <div class="btn-icon">
                    <iconSymbol :name="'edraw-turnleft'" @click.native="rotateLeft" />
                    <iconSymbol :name="'edraw-turnright'" @click.native="rotateRight" />
                    <iconSymbol :name="'edraw-scalebig'" @click.native="changeScale(2)" />
                    <iconSymbol :name="'edraw-scalesmall'" @click.native="changeScale(-2)" />
                </div>
            </div>
            <div class="edit-confirm">
                <Button type="error" size="small" @click="cancel">{{ $t("cancel") }}</Button>
                <Button type="primary" size="small" @click="takeImg">{{ $t("save") }}</Button>
            </div>
        </Dialog>
    </div>
</template>

<script>
    import "./style/editUserInfoDialog.styl";
    export default {
        components: {},
        data() {
            return {
                newImg: null,
                prShow: true,
            };
        },
        computed: {
            ishow: {
                get() {
                    return this.$store.state.userPage.isPicture;
                },
                set() {
                    this.$store.commit("userPage/controlBoxShow", {
                        type: "isPicture",
                        isShow: false,
                    });
                },
            },
            picture() {
                return this.$store.state.userPage.picturefile;
            },
            type() {
                return this.$store.state.userPage.picturType;
            },
        },
        watch: {
            ishow(val) {
                if (!val) {
                    Object.assign(this.$data, this.$options.data());
                    this.$store.commit("userPage/getPitcture", null);
                } else {
                    console.log(11);
                    setTimeout(() => {
                        this.preview();
                    }, 100);
                }
            },
            picture(val) {
                this.newImg = val;
            },
        },
        methods: {
            selectImg() {
                this.$refs.avafile.click();
            },
            closed() {
                Object.assign(this.$data, this.$options.data());
            },
            preview() {
                this.$refs.cropper &&
                    this.$refs.cropper.getCropData((data) => {
                        this.newImg = data;
                    });
            },
            rotateLeft() {
                this.$refs.cropper && this.$refs.cropper.rotateLeft();
                this.preview();
            },
            rotateRight() {
                this.$refs.cropper && this.$refs.cropper.rotateRight();
                this.preview();
            },
            changeScale(type) {
                this.$refs.cropper && this.$refs.cropper.changeScale(type);
                this.preview();
            },
            cancel() {
                this.ishow = false;
                Object.assign(this.$data, this.$options.data());
            },
            takeImg() {
                let params = {
                    id: this.$store.state.userInfo.user_id,
                    token: this.$store.state.userInfo.token,
                };
                const _this = this;
                _this.$refs.cropper.getCropData((data) => {
                    _this.newImg = data;
                    _this.$edApi.GetEditImgSign(params, _this.type).then((res) => {
                        _this.$edApi.sendPersonalImg(res.data, _this.dataURLtoBlob(_this.newImg)).then((res) => {
                            if (res.statusText === "OK") {
                                _this.$store.dispatch("userPage/getIntervieweeUserInfo");
                                _this.$store.dispatch("userPage/getUserInfo");
                                _this.$edMessage.success("上传成功！");
                                window.$qt.jsCallUpdatePhoto();
                                _this.cancel();
                            } else {
                                _this.$edMessage.error("上传失败，请重试！");
                            }
                        });
                    });
                });
            },
            dataURLtoBlob(img) {
                var arr = img.split(","),
                    mime = arr[0].match(/:(.*?);/)[1],
                    bstr = atob(arr[1]),
                    n = bstr.length,
                    u8arr = new Uint8Array(n);
                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n);
                }
                return new Blob([u8arr], { type: mime });
            },
            getAvatar(item) {
                let ava = "";
                if (item.avatar) ava = "data:image/png;base64," + item.avatar;
                else if (item.avatar_url) ava = item.avatar_url;
                return ava;
            },
            reChoose(e) {
                let fr = new FileReader(),
                    file = e.target.files[0],
                    _self = this;
                fr.onload = function () {
                    _self.$store.commit("userPage/getPitcture", fr.result);
                    _self.$refs.avafile.value = null;
                };
                fr.readAsDataURL(file);
            },
        },
        mounted() {
            const _this = this;
            window.addEventListener("keyup", function (e) {
                if (e.code == "Escape") {
                    _this.cancel();
                }
            });
        },
        beforeDestroy() {
            window.removeEventListener("keyup", function (e) {
                if (e.code == "Escape") {
                    _this.cancel();
                }
            });
        },
    };
</script>

<i18n>
{
  "zh": {
    "uploadAvatar": "上传头像",
    "Reselect": "重新选择",
    "save": "保存",
    "cancel": "取消",
    "avatarPreview": "头像预览"
  },
  "en": {
    "uploadAvatar": "Upload Avatar",
    "Reselect": "Reselect",
    "save": "Save",
    "cancel": "Cancel",
    "avatarPreview": "Avatar Preview"
  },
  "fr": {
    "uploadAvatar": "Uploader la photo de profil",
    "Reselect": "Resélectionner",
    "save": "Enregistrer",
    "cancel": "Annuler",
    "avatarPreview": "Aperçu"
  },
  "de": {
    "uploadAvatar": "Avatar hochladen",
    "Reselect": "Erneut auswählen",
    "save": "speichern",
    "cancel": "Abbrechen",
    "avatarPreview": "Avatar-Vorschau"
  },
  "jp": {
    "uploadAvatar": "アバターをアップロード",
    "Reselect": "画像を置換",
    "save": "保存",
    "cancel": "キャンセル",
    "avatarPreview": "プレビュー"
  },
  "es": {
    "uploadAvatar": "Subir avatar",
    "Reselect": "Volver a seleccionar",
    "save": "Guardar",
    "cancel": "Cancelar",
    "avatarPreview": "Previsualización de avatares"
  },
  "pt": {
    "uploadAvatar": "Carregar foto do perfil",
    "Reselect": "Carregar foto do perfil",
    "save": "Salvar",
    "cancel": "Cancelar",
    "avatarPreview": "Pre-visualização da foto do perfil"
  },
  "it": {
    "uploadAvatar": "Carica immagine",
    "Reselect": "Seleziona di nuovo",
    "save": "Salva",
    "cancel": "Annulla",
    "avatarPreview": "Anteprima dell'immagine"
  },
  "tw": {
    "uploadAvatar": "上傳頭像",
    "Reselect": "重新選擇",
    "save": "保存",
    "cancel": "取消",
    "avatarPreview": "頭像預覽"
  },
  "kr": {
    "uploadAvatar": "프로필 사진 업로드",
    "Reselect": "다시 선택",
    "save": "저장",
    "cancel": "취소",
    "avatarPreview": "미리보기"
  },
  "id": {
    "uploadAvatar": "Unggah Avatar",
    "Reselect": "Pilih ulang",
    "save": "Simpan",
    "cancel": "Batalkan",
    "avatarPreview": "Pratinjau Avatar"
  }
}
</i18n>
